export default __webpack_public_path__ + "static/media/activeMarker.4cdfda94.svg";